export default function calculateGroupedNutrient(group, nutrient, area) {
    let weightedNutrient = 0.0;
    group.forEach(
      (block) => (weightedNutrient += block.requirements[0][nutrient] * block.hectares)
    );
    return Math.round(weightedNutrient / area);
  }